









































import { defineComponent, PropType } from '@vue/composition-api';
import MenuIconButton from '@front-app/components/form/tiptap/MenuIconButton.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { TextAlignment } from './alignmentButtons';

export default defineComponent({
	components: {
		MenuIconButton,
		FontAwesomeIcon,
	},
	props: {
		value: {
			type: String as PropType<TextAlignment>,
			required: true,
		},
	},
	setup() {
		return {
			TextAlignment,
		};
	},
});
